import { t } from '@glory/i18n';
import { PageHeader } from '@glory/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DevicesSection } from '../../../features/e2ee/devices-section.tsx';
import { MailSection } from '../../../features/security/mail-section.tsx';
import { PasskeysSection } from '../../../features/security/passkeys-section.tsx';
import { PasswordSection } from '../../../features/security/password-section.tsx';
import { SessionsSection } from '../../../features/security/sessions-section.tsx';
import { TwoFactorSection } from '../../../features/security/two-factor-section.tsx';
import { useCrumbs } from '../../../lib/crumbs.tsx';
import { meQuery } from '../../../lib/session.ts';

export const Route = createFileRoute('/_app/profile/security')({
  component: SecurityPage,
});

function SecurityPage() {
  const { data: me } = useSuspenseQuery(meQuery);
  useCrumbs([{ label: t('shell.profile') }, { label: t('security.title') }]);
  return (
    <div className="flex flex-col gap-4 px-4 py-5 md:px-6">
      <PageHeader crumb={me.email} title={t('security.title')} />
      <p className="-mt-2 text-muted">{t('security.lead')}</p>
      <PasskeysSection />
      <TwoFactorSection enabled={me.twoFactorEnabled} />
      <PasswordSection />
      <SessionsSection />
      <DevicesSection />
      <MailSection />
    </div>
  );
}
